import { StorageService } from './../../providers/storage.service';
import { Component } from '@angular/core';
import { NavParams,ViewController } from 'ionic-angular';
import { CurrLotteryModel,PlayModeModel, PlayDetailModel } from '../../models/betting.model';
import { GroupByPipe } from 'ng-pipes';
/*
  投注选择页面
  chen 2017-03-01
*/
@Component({
    selector: 'play-select',
    templateUrl: 'playSelect.html',
    providers:[GroupByPipe]
})
export class PlaySelectPage {

    currlottery= new CurrLotteryModel();
    playModes:PlayModeModel[];
    playMode:PlayModeModel;
    playDetails:PlayDetailModel[];
    currPlayDetails;
    currPlayDetail:PlayDetailModel;
    currDetailName="";
    playGroup="";
    tracks={};

    constructor(
        private viewCtrl: ViewController,
        private navPar: NavParams,
        private storage: StorageService,
        private groupBy: GroupByPipe

    ) { 
        this.currlottery = this.navPar.get("currlottery");
        this.currDetailName = this.navPar.get("currPlayDetailName");
        this.playModes = this.currlottery.PlayModes;
        this.playMode = this.currlottery.PlayMode;
        this.playDetails = this.playMode.PlayDetails;
        this.playGroup = this.navPar.get("PlayGroup");
    }

    //页面初始加载
    //chen 2017-03-02
    ionViewDidLoad() {
        let cachedplaymode = this.storage.read<PlayModeModel>('cachedPlayMode' + this.currlottery.LotteryCode);
        if (cachedplaymode) {
            this.currlottery.PlayMode = cachedplaymode;
        }
        this.onPlayModeClick(this.currlottery.PlayMode);
    }

    //模式点击事件
    //chen 2017-03-01
    onPlayModeClick(x:PlayModeModel){
        this.playMode = x;
        this.storage.write('cachedPlayMode' + this.currlottery.LotteryCode, x);
        let playDetails = this.groupBy.transform(x.PlayDetails, "PlayGroup");
        let firstArray: PlayDetailModel[][] = [];
        let lastArray: PlayDetailModel[][] = [];
        for (var i in playDetails) {
            let details: PlayDetailModel[] = playDetails[i];
            if (playDetails[i]["PlayGroup"]) {
                firstArray.push(details);
            } else {
                lastArray.push(details);
            }
        }
        this.currPlayDetails = firstArray.concat(lastArray);
        this.currDetailName=x.LotteryPlayModeCode!=this.currlottery.PlayMode.LotteryPlayModeCode? "":this.currDetailName;        
        // this.currDetailName=this.currDetailName=="" || x.LotteryPlayModeCode!=this.currlottery.PlayMode.LotteryPlayModeCode? x.PlayDetails[0].LotteryPlayDetailName:this.currDetailName;
    }

    //玩法细节点击
    //chen 2017-03-02
    initPlayDetail(x: PlayDetailModel){
        this.currPlayDetail=x;
        this.currDetailName=x.LotteryPlayDetailName;
        this.playGroup=x.PlayGroup;
        this.close();
    }

    //弹窗关闭
    //chen 2017--3-02
    close(data?:any){
        this.tracks={
            playMode:this.playMode,
            playDetailName:this.currDetailName,
            playDetail:this.currPlayDetail,
            PlayGroup:this.playGroup
        };
        this.viewCtrl.dismiss(this.tracks);
    }
}


// WEBPACK FOOTER //
// ./src/pages/bettingorder/playSelect.ts